<template>
    <div class="container-fluid">
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <table
                            class="table"
                            v-if="!loading && templates.length"
                        >
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Subject</th>
                                    <th>From</th>
                                    <th>Content</th>
                                    <th>Updated at</th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(template, index) in templates"
                                    :key="index"
                                >
                                    <td>
                                        <router-link :to="{name: 'admin.email_templates.edit', params: { id: template.id } }">
                                            {{ template.name }}
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{name: 'admin.email_templates.edit', params: { id: template.id } }">
                                            {{ template.subject.substr(0, 25) }}<span v-if="template.subject.length > 24">...</span>
                                        </router-link>
                                    </td>
                                    <td>
                                        <router-link :to="{name: 'admin.email_templates.edit', params: { id: template.id } }">
                                            {{ template.from }}
                                        </router-link>
                                    </td>
                                    <td>
                                        {{ template.content.substr(0, 50) }}<span v-if="template.content.length > 49">...</span>
                                    </td>
                                    <td>
                                        {{ template.updated_at || '-' }}
                                    </td>
                                    <td class="text-right">
                                        <router-link
                                            :to="{name: 'admin.email_templates.edit', params: { id: template.id } }"
                                            class="row-icon"
                                        >
                                            <i class="fa fa-pencil-alt" />
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <p v-if="!loading && templates.length === 0">
                            No templates to show
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Service from '../../../services/EmailTemplatesService';

export default {
    data: function () {
        return {
            templates: [],
            loading: false,
        }
    },

    mounted: function () {
        this.loading = true;
        Service.search().then(xhr => {
            this.templates = xhr.data;
            this.loading = false;
        }, error => {
            alert('Error: Could not load email templates');
            this.loading = false;
        });
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/email-templates/SearchComponent.vue